const SimpleArrowIcon = ({
  className = '',
  stroke = '#442E83',
  ...otherProps
}) => (
  <svg
    width='6'
    height='10'
    viewBox='0 0 6 11'
    fill='none'
    className={className}
    {...otherProps}
  >
    <path
      d='M1 1.00122L5 5.00122L1 9.00122'
      stroke={stroke}
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default SimpleArrowIcon
